import Vue from "vue";

export const RefressBus = new Vue();
